var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEscalator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-escalator",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 28,
    height: 28,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M28.417,16.05a5.23,5.23,0,0,1-5.224,5.224H21.329L13.967,30.74a4.558,4.558,0,0,1-3.621,1.771H6.2a5.133,5.133,0,0,1-4.037-2.333h8.18a2.239,2.239,0,0,0,1.779-.87l8.062-10.366h3a2.891,2.891,0,1,0,0-5.781H19.07a2.24,2.24,0,0,0-1.779.87L9.229,24.4h-3a2.894,2.894,0,0,0-2.891,2.891v1.207H1V27.286a5.23,5.23,0,0,1,5.224-5.224H8.087L15.449,12.6a4.558,4.558,0,0,1,3.621-1.771h4.122A5.23,5.23,0,0,1,28.417,16.05Z",
    transform: "translate(-0.708 -7.668)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEscalator);
export default __webpack_public_path__ + "static/media/ico-escalator.0ed70ecd2bedb48b5a58305c1e7e5efd.svg";
export { ForwardRef as ReactComponent };